export default "__VITE_ASSET__2RIwiBnn__"